import { BigNumber } from "../../classes/BigNumber";
import { iApiConfig, tAddress, tDiscountPercent } from "../../interfaces";
import { tDispatch } from "../store";
import { eAppActionTypes } from "./appTypes";

export const clearAppState = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.CLEAR_STATE
		})
	}
}

export const setDiscountPercent = (percent: tDiscountPercent) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_DISCOUNT_PERCENT,
			payload: percent
		})
	}
}

export const setUserAddress = (address: tAddress) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_USER_ADDRESS,
			payload: address
		})
	}
}

export const setApiData = (percent: tDiscountPercent, api: string, config: iApiConfig) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_API_DATA,
			payload: {
				percent,
				api,
				config
			}
		})
	}
}

export const setIsInited = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_IS_INITED,
			payload: true
		})
	}
}

export const setMinDeposit = (percent: tDiscountPercent, amount: BigNumber) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_MIN_DEPOSIT,
			payload: {
				percent,
				amount
			}
		})
	}
}

export const setKasAccessToken = (token: string) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_KAS_ACCESS_TOKEN,
			payload: token
		})
	}
}